import {
  POS_PLATFORM_LOADING,
  POS_PLATFORM_CONFIG,
  POS_PLATFORM_ERROR,
  POS_CATEGORIES,
  POS_ITEMS,
  POS_ITEMS_APPEND,
  POS_TOP_ITEMS,
  POS_CATALOG_LOADING,
  POS_PLATFORM_RESET,
  POS_SEARCH_LOADING,
  POS_SEARCH_RESULTS,
  POS_SEARCH_CLEAR,
} from "./actionTypes";

const initialState = {
  loading: false,
  error: null,
  config: null,
  categories: [],
  items: [],
  itemsTotal: 0,
  nextCursor: null,
  catalogLoading: false,
  searchResults: [],
  searching: false,
  searchActive: false,
  topItems: [],
  topLoading: false,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case POS_PLATFORM_LOADING:
      return { ...state, loading: true, error: null };

    case POS_PLATFORM_CONFIG:
      return { ...state, loading: false, config: action.payload, error: null };

    case POS_PLATFORM_ERROR:
      return { ...state, loading: false, error: action.payload };

    case POS_CATEGORIES:
      return { ...state, categories: action.payload };

    case POS_CATALOG_LOADING:
      return { ...state, catalogLoading: action.payload };

    case POS_TOP_ITEMS:
      return { ...state, topItems: action.payload, topLoading: false };

    case POS_ITEMS:
      return {
        ...state,
        items: action.payload.items,
        itemsTotal: action.payload.total,
        nextCursor: action.payload.next_cursor,
        catalogLoading: false,
      };

    case POS_ITEMS_APPEND:
      return {
        ...state,
        items: [...state.items, ...action.payload.items],
        itemsTotal: action.payload.total,
        nextCursor: action.payload.next_cursor,
        catalogLoading: false,
      };

    case POS_SEARCH_LOADING:
      return { ...state, searching: action.payload, searchActive: true };

    case POS_SEARCH_RESULTS:
      return { ...state, searchResults: action.payload, searching: false, searchActive: true };

    case POS_SEARCH_CLEAR:
      return { ...state, searchResults: [], searching: false, searchActive: false };

    case POS_PLATFORM_RESET:
      return initialState;

    default:
      return state;
  }
}
